/** Énumération répertoriant les résultats d'export. */
export enum EExportResult {
	patientFailed = "patientFailed",
	patientSuccess = "patientSuccess",
	partialActesSuccess = "partialActesSuccess",
	actesFailed = "actesFailed",
	actesSuccess = "actesSuccess",
	patientUpdated = "patientUpdated"
}